import TsdiCounty from 'src/models/projectSettings/TsdiCounty';

export default class TsdiAltSubcode {
    subcodeId?: number;
    id?: number;
    number?: number;
    name?: string;
    grossAcres?: number;
    afeNumber?: string;
    clmNumber?: number;
    clientAccountCode?: string;
    costCenter?: string;
    counties?: Array<TsdiCounty>;
}


// WEBPACK FOOTER //
// ./src/models/AP/AltSubcode.ts